module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAARNJREFUOE+10z1Lw1AYhuH7aTUJoihIFkfj5OYv0aEKguCmizh0UlwyaTcHNzcXKyjo4g8QXHUXTHAQBEHo1jZijrTFRfPVEs98zsXzfhxR0lFJDv8PGX9uAttZ1n7YLJI6NVEfsux7KrpjL6wLTBaYWZppzE8Tc4t44jHc0iVfaVhujwbJnGtQi9mZDW0/fCZhuVDvkfEXLaxOE+FgRzXVX9u/sULQAHMnsaZCjHZ1EFyMBPUT2Z0b4INuuCmfeGjI+Iwx7l1RIcIL1rWW3PDsqa1SZck7BxxegppOSWx0L136HhnEkXcGsctbdUUnz92R9sgcLrgobvAe7ej475SG7lGR75FZWlHg517hPcqDS4O+AVQvSRPNBGiwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_arrow_2.png
// module id = R3ba
// module chunks = 1